import {Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef, Input, OnChanges} from '@angular/core';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'ngx-tiny-mce',
  template: '',
})
export class TinyMCEComponent implements AfterViewInit, OnDestroy, OnChanges {

  @Output() editorKeyup = new EventEmitter<any>();
  @Input() contentEvent: string;

  editor: any;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy,
  ) { }
  ngAfterViewInit() {
    tinymce.init({
      target: this.host.nativeElement,
      plugins: ['link'],
      skin_url: `${this.locationStrategy.getBaseHref()}static/assets/skins/lightgray`,
      toolbar: 'formatting | undo redo | italic bold | link | formatselect fontsizeselect',
      menubar: false,
      setup: editor => {
        this.editor = editor;
        editor.on('change', () => {
          this.editorKeyup.emit(editor.getContent());
        });
      },
      height: '320',
    });
  }

  ngOnChanges() {
    if (this.editor) {
      if (this.contentEvent && this.contentEvent.length > 0) {
        this.editor.setContent(this.contentEvent);
      } else {
        this.editor.setContent('');
      }
    }
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

}
